import { i18n } from '@/locales';
// https://www.notion.so/1387e2701cc349d8b44a73cbdadc1c67?d=eeb843e77812441fbc403ab76a3ccc22&pvs=4#b9626f3e84c34902ab06f4703a5ec3ee
const deliveryPayTypeCode = [
    /** 현금 */
    {
        value: '1',
        text: 'pay_cash',
        color: 'green',
    },
    /** 바로머니 */
    {
        value: '2',
        text: 'pay_baromoney',
        color: 'blue',
    },
    /** 고객? */
    {
        value: '3',
        text: 'customer_pay',
        color: 'purple',
    },
];
/** 배달대행료 지불 방식 */
const deliveryPayType = {};
deliveryPayTypeCode.forEach(({ value, text, color, }) => {
    deliveryPayType[value] = {
        text: i18n.t(`common.delivery_pay_type.${text}`),
        value,
        color,
    };
});
export default deliveryPayType;
